module.exports = __webpack_public_path__ + "img/save-modal-x.bf1836c1.svg";